<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
  <div class="min-h-screen bg-gray-50 p-6">
  <!-- 通知区域 -->
  <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
  <div class="font-medium text-lg mb-4">平台通知</div>
  <div class="max-h-40 overflow-y-auto" style="scrollbar-width: thin">
  <div class="flex items-center justify-between p-3 border rounded-lg mb-2 hover:bg-gray-50"
    v-for="(activity, index) in activities"
            :key="index"
  >
    <div class="flex items-center space-x-2">
    <i class="fas fa-bell text-blue-500"></i>
    <span> {{activity.content}}  </span>  
    </div>
    <div class="flex items-center space-x-4">
    <button class="btn-primary !rounded-button whitespace-nowrap text-sm px-3 py-1"
    v-if="activity.is_op == 1" 
              @click='jumpClick(activity)'
    >前往处理</button>
    <button class="btn-default !rounded-button whitespace-nowrap text-sm px-3 py-1"
    v-if="activity.isread == 0" @click='labelClick(activity.id)'
    >标为已读</button>
    </div>
  </div>
  <div v-if='activities.length <= 0' style='width:100%;text-align:center;line-height:100px;font-size:16px;color:#3A8EE6;'>
            暂无处理事项

        </div>

  </div>
  </div>

  <!-- 系统概览数据 -->
  <div class="grid grid-cols-5 gap-6 mb-6" v-if="obj">
  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
      <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
      <span>供应商数量</span>
      </div>
      <div class="text-3xl font-medium">{{ obj.supply.total }}</div>
      <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.supply.increase }} 家</div>
  </div>
  
  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
  <i class="fas fa-truck text-blue-500 text-xl mr-2"></i>
  <span>司机数量</span>
  </div>
  <div class="text-3xl font-medium">{{ obj.driver.total }}</div>
  <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.driver.increase }} 人</div>
  </div>
  
  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
  <i class="fas fa-users text-blue-500 text-xl mr-2"></i>
  <span>业务员数量</span>
  </div>
  <div class="text-3xl font-medium">{{ obj.saler.total }}</div>
  <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.saler.increase }} 人</div>
  </div>
  
  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
  <i class="fas fa-file text-blue-500 text-xl mr-2"></i>
  <span>订单</span>
  </div>
  <div class="text-3xl font-medium">{{ obj.order.total }}</div>
  <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.order.increase }} 单</div>
  </div>
  
  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
  <i class="fas fa-map-marker-alt text-blue-500 text-xl mr-2"></i>
  <span>线路</span>
  </div>
  <div class="text-3xl font-medium">{{ obj.line.total }}</div>
  <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.line.increase }} 条</div>
  </div>

  <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
  <div class="flex items-center text-gray-600 mb-4">
  <i class="fas fa-map-marker-alt text-blue-500 text-xl mr-2"></i>
  <span>发货单</span>
  </div>
  <div class="text-3xl font-medium">{{ obj.ddelivery.total }}</div>
  <div class="text-sm text-gray-500 mt-2">较上月 +{{ obj.ddelivery.increase }} 条</div>
  </div>



  </div>


  <!-- 筛选条件区域 -->
  <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
  <div class="grid grid-cols-4 gap-4">
  <!-- <div class="relative">
  <div class="border rounded px-3 py-2 cursor-pointer" @click="toggleWarehouseDropdown">
  {{selectedWarehousesText}}
  <i class="fas fa-chevron-down absolute right-2 top-3"></i>
  </div>
  <div v-if="showWarehouseDropdown" class="absolute z-10 w-full bg-white border rounded mt-1 shadow-lg">
  <div v-for="item in warehouses" :key="item.value" 
  class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
  @click="selectWarehouse(item)">
  {{item.label}}
  </div>
  </div>
  </div> -->
  
  <!-- <div class="relative">
  <div class="border rounded px-3 py-2 cursor-pointer" @click="toggleLocationDropdown">
  {{selectedLocationsText}}
  <i class="fas fa-chevron-down absolute right-2 top-3"></i>
  </div>
  <div v-if="showLocationDropdown" class="absolute z-10 w-full bg-white border rounded mt-1 shadow-lg">
  <div v-for="item in locations" :key="item.value" 
  class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
  @click="selectLocation(item)">
  {{item.label}}
  </div>
  </div>
  </div> -->
  
  <div class="relative">
  <div class="border rounded px-3 py-2 cursor-pointer" @click="toggleSupplierDropdown">
  {{selectedSupplier ? selectedSupplier.name : '选择供应商'}}
  <i class="fas fa-chevron-down absolute right-2 top-3"></i>
  </div>
  <div v-if="showSupplierDropdown" class="absolute z-10 w-full bg-white border rounded mt-1 shadow-lg">
  <div v-for="item in supply" :key="item.supply_id" 
  class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
  @click="selectSupplier(item)">
  {{item.name}}
  </div>
  </div>
  </div>
  
  <div class="flex space-x-2">
  <input type="date" v-model="form.startDate" class="border rounded px-3 py-2">
  <span class="py-2">至</span>
  <input type="date" v-model="form.endDate" class="border rounded px-3 py-2">
  </div>
  </div>
  
  <div class="flex justify-end mt-4 space-x-4">
  <button class="btn-primary !rounded-button whitespace-nowrap px-4 py-2" @click="handleSearch">查询</button>
  <button class="btn-default !rounded-button whitespace-nowrap px-4 py-2" @click="handleReset">重置</button>
  </div>
  </div>

  <!-- 图表区域 -->
  <div class="grid grid-cols-1 gap-1 mb-6">
      <div class="bg-white p-6 rounded-lg shadow-sm">
          <div class="text-lg font-medium mb-4">进出货趋势</div>
          <div ref="trendChart" class="h-80"></div>
      </div>

  </div>




  <!-- <div class="grid grid-cols-1 gap-1 mb-6">

      <div class="bg-white p-6 rounded-lg shadow-sm">
            <div class="text-lg font-medium mb-4">仓库进出额占比分析</div>
            <div ref="pieChart" class="h-80" style="min-height: 800px;"></div>
      </div>
  </div> -->
  <!-- 表格区域 -->
  <div class="bg-white rounded-lg shadow-sm p-6">
  <div class=" justify-between items-center mb-4">
  <div class="text-lg font-medium">入库数据</div>


  <div class="ba_f outmain">
 
        <el-form :inline="false" :model="form_w" class="demo-form-inline" label-width="100px">
          <div class="flex ba_f" >
            <el-form-item label="查询日期：" class="mar_t20">
              <div class="flex-bet">
                <div>
                  <el-radio-group  v-model="form_w.timeType" @change="selectTypew">
                    <el-radio-button label="1">今天</el-radio-button>
                    <el-radio-button label="2">近七天</el-radio-button>
                    <el-radio-button label="3">近十五天</el-radio-button>
                    <el-radio-button label="4">自定义时间</el-radio-button>
       
                  </el-radio-group>
                  <span class="mar_l20" v-if="form_w.timeType=='4'">
                  <el-date-picker v-model="form_w.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期" format="yyyy年MM月dd日" :picker-options="pickerOptions" @change="selectTypew"></el-date-picker>
                </span>
     
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="flex ba_f" >

            <!-- <el-form-item label="从哪入库：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_w.supply_id" placeholder="请选择" @change="changeStorew" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item> -->


            <el-form-item label="入库到哪：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_w.t_supply_id" placeholder="请选择" @change="changeStorew" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="选择产品："  width="300">
              <div class="mar_l20">
                <el-select v-model="form_w.product_sku_id" placeholder="请选择" @change="changeStorew" filterable>
                  <el-option v-for="item in productArr" :key="item.product_sku_id" 
                  :label="item.product_name+'(规格:'+item.spec+':'+')'+'(ID:'+item.product_sku_id+')'"
                            :value="item.product_sku_id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>


       
        </el-form>
      </div>


  <div class="product-content">
        <el-form ref="formw" :model="formw" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableDataw" border style="width: 100%" v-loading="loading">
                <el-table-column prop="supply.name" label="供应商/商家ID-从哪入库"></el-table-column>
                <el-table-column prop="t_supply.name" label="供应商/商家ID-入库到哪"></el-table-column>
  
              
                <el-table-column prop="warehouse_wk_name" label="库位"></el-table-column>
                <el-table-column prop="warehouse_management_id" label="入库ID"></el-table-column>
                <el-table-column prop="warehouse_management.inboundOrderNumber" label="入库单号"></el-table-column>

                <el-table-column prop="type" label="类型">
                    <template #default="{row}">
                        {{ 
                        row.type === 0 ? '市场采购' : 
                        row.type === 1 ? '供应商采购' : 
                        row.type === 2 ? '售后入库' : '未知'
                        }}
                    </template>
                </el-table-column>

            
                <el-table-column prop="product_id" label="产品ID"></el-table-column>
                <el-table-column prop="product_sku_id" label="产品SKUID"></el-table-column>
                <el-table-column prop="product_name" label="产品名称"></el-table-column>

                <el-table-column prop="product_price" label="产品价格">
                <template #default="{row}">
                    ¥{{ parseFloat(row.product_price).toFixed(2) }}
                </template>
                </el-table-column>

                <el-table-column prop="product_num" label="入库数量"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="spec_value" label="规格"></el-table-column>

                <el-table-column prop="file_path" label="图片">
                <template #default="{row}">
                    <el-image 
                    v-if="row.file_path"
                    :src="row.file_path" 
                    style="width: 50px; height: 50px"
                    :preview-src-list="[row.file_path]"
                    ></el-image>
                    <span v-else>无图片</span>
                </template>
                </el-table-column>

                <el-table-column prop="category_name" label="分类"></el-table-column>
                <el-table-column prop="create_time" label="入库时间"></el-table-column>
    
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChangew"
            @current-change="handleCurrentChangew"
            background
            :current-page="curPagew"
            :page-size="pageSizew"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumberw"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>



  <div class="bg-white rounded-lg shadow-sm p-6">
  <div class=" justify-between items-center mb-4">
  <div class="text-lg font-medium">出库数据</div>


  <div class="ba_f outmain">
    
        <el-form :inline="false" :model="form_o" class="demo-form-inline" label-width="100px">
          <div class="flex ba_f" >
            <el-form-item label="查询日期：" class="mar_t20">
              <div class="flex-bet">
                <div>
                  <el-radio-group  v-model="form_o.timeType" @change="selectTypeo">
                    <el-radio-button label="1">今天</el-radio-button>
                    <el-radio-button label="2">近七天</el-radio-button>
                    <el-radio-button label="3">近十五天</el-radio-button>
                    <el-radio-button label="4">自定义时间</el-radio-button>
       
                  </el-radio-group>
                  <span class="mar_l20" v-if="form_o.timeType=='4'">
                  <el-date-picker v-model="form_o.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期" format="yyyy年MM月dd日" :picker-options="pickerOptions" @change="selectTypeo"></el-date-picker>
                </span>
     
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="flex ba_f" >

            <el-form-item label="从哪入库：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_o.supply_id" placeholder="请选择" @change="changeStoreo" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item>


            <el-form-item label="入库到哪：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_o.t_supply_id" placeholder="请选择" @change="changeStoreo" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="选择产品："  width="300">
              <div class="mar_l20">
                <el-select v-model="form_o.product_sku_id" placeholder="请选择" @change="changeStoreo" filterable>
                  <el-option v-for="item in productArr" :key="item.product_sku_id" 
                  :label="item.product_name+'(规格:'+item.spec+':'+')'+'(ID:'+item.product_sku_id+')'"
                            :value="item.product_sku_id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>


       
        </el-form>
      </div>


      <div class="product-content">
        <el-form ref="formo" :model="formo" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableDatao" border style="width: 100%" v-loading="loading">
                <el-table-column prop="supply.name" label="供应商/商家ID-从哪出库"></el-table-column>
                <el-table-column prop="t_supply.name" label="供应商/商家ID-出库到哪"></el-table-column>
  
              
                <el-table-column prop="warehouse_wk_name" label="库位"></el-table-column>
                <el-table-column prop="out_management_id" label="出库ID"></el-table-column>
                <el-table-column prop="out_management.order_umber" label="出库单号"></el-table-column>

    

            
                <el-table-column prop="product_id" label="产品ID"></el-table-column>
                <el-table-column prop="product_sku_id" label="产品SKUID"></el-table-column>
                <el-table-column prop="product_name" label="产品名称"></el-table-column>

                <el-table-column prop="product_price" label="产品价格">
                <template #default="{row}">
                    ¥{{ parseFloat(row.product_price).toFixed(2) }}
                </template>
                </el-table-column>

                <el-table-column prop="product_num" label="出库数量"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="spec_value" label="规格"></el-table-column>

                <el-table-column prop="file_path" label="图片">
                <template #default="{row}">
                    <el-image 
                    v-if="row.file_path"
                    :src="row.file_path" 
                    style="width: 50px; height: 50px"
                    :preview-src-list="[row.file_path]"
                    ></el-image>
                    <span v-else>无图片</span>
                </template>
                </el-table-column>

                <el-table-column prop="category_name" label="分类"></el-table-column>
                <el-table-column prop="create_time" label="出库时间"></el-table-column>
    
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChangeo"
            @current-change="handleCurrentChangeo"
            background
            :current-page="curPageo"
            :page-size="pageSizeo"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumbero"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="bg-white rounded-lg shadow-sm p-6">
  <div class="flex justify-between items-center mb-4">
  <div class="text-lg font-medium">供应链明细数据</div>
  <div class="space-x-4">
  <button class="btn-primary !rounded-button whitespace-nowrap px-4 py-2" @click="handleExport">
  <i class="fas fa-download mr-1"></i>导出
  </button>
  <button class="btn-default !rounded-button whitespace-nowrap px-4 py-2" @click="handlePrint">
  <i class="fas fa-print mr-1"></i>打印
  </button>
  <button class="btn-default !rounded-button whitespace-nowrap px-4 py-2" @click="handleRefresh">
  <i class="fas fa-sync mr-1"></i>刷新
  </button>
  </div>
  </div>
  
  <table class="w-full border-collapse">
  <thead>
  <tr class="bg-gray-50">
  <th class="border px-4 py-2 text-left">日期</th>
  <th class="border px-4 py-2 text-left">仓库</th>
  <th class="border px-4 py-2 text-left">库位</th>
  <th class="border px-4 py-2 text-left">供应商</th>
  <th class="border px-4 py-2 text-left">类型</th>
  <th class="border px-4 py-2 text-left">金额</th>
  <th class="border px-4 py-2 text-left">库存</th>
  <th class="border px-4 py-2 text-left">配送司机</th>
  <th class="border px-4 py-2 text-left">配送线路</th>
  <th class="border px-4 py-2 text-left">状态</th>
  <th class="border px-4 py-2 text-left">操作</th>
  </tr>
  </thead>
  <tbody>
  <tr v-for="item in tableData" :key="item.date">
  <td class="border px-4 py-2">{{item.date}}</td>
  <td class="border px-4 py-2">{{item.warehouse}}</td>
  <td class="border px-4 py-2">{{item.location}}</td>
  <td class="border px-4 py-2">{{item.supplier}}</td>
  <td class="border px-4 py-2">{{item.type}}</td>
  <td class="border px-4 py-2">{{item.amount}}</td>
  <td class="border px-4 py-2">{{item.inventory}}</td>
  <td class="border px-4 py-2">{{item.driver}}</td>
  <td class="border px-4 py-2">{{item.route}}</td>
  <td class="border px-4 py-2">{{item.status}}</td>
  <td class="border px-4 py-2">
  <button class="btn-primary !rounded-button whitespace-nowrap text-sm px-3 py-1" @click="handleDetail(item)">
  查看详情
  </button>
  </td>
  </tr>
  </tbody>
  </table>
  
  <div class="flex justify-end mt-4 items-center space-x-2">
  <span>总计 {{total}} 条</span>
  <select v-model="pageSize" class="border rounded px-2 py-1">
  <option v-for="size in [10,20,50,100]" :key="size" :value="size">{{size}}条/页</option>
  </select>
  <button class="px-3 py-1 border rounded" :disabled="currentPage === 1" @click="currentPage--">上一页</button>
  <span>第 {{currentPage}} 页</span>
  <button class="px-3 py-1 border rounded" :disabled="currentPage * pageSize >= total" @click="currentPage++">下一页</button>
  </div>
  </div> -->
  </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import IndexApi from "@/api/index.js";
  import Existing_inventoryApi from '@/api/existing_inventory.js';
  import Warehouse_managementApi from '@/api/warehouse_management.js';
  import Out_managementApi from '@/api/out_management.js';
  import { changeDate } from '@/utils/index';
  export default {
    data() {
      return {
        selectedWarehouses: [],
        selectedLocations: [],
        selectedSupplier: null,
        selectedSuppliers: null,
       form:{
        startDate: '',
        endDate: '',
       },
        currentPage: 1,
        pageSize: 10,
        total: 1000,
        showWarehouseDropdown: false,
        showLocationDropdown: false,
        showSupplierDropdown: false,

       

        activities: [],
        obj:{},
        supply:[],
        warehouse:[],


        tableDataw:[],
        formw:[],
        /*列表数据*/
         tableDataw: [],
          /*一页多少条*/
          pageSizew: 20,
          /*一共多少条数据*/
          totalDataNumberw: 0,
          /*当前是第几页*/
          curPagew: 1,

          form_w:{
            shopValue: '',
            timeType: '3',
            time: [new Date(), new Date()],
            Mtime: '',
            supply_id:0,
            t_supply_id:0,
            product_sku_id:0,
          },
          form_o:{
            shopValue: '',
            timeType: '3',
            time: [new Date(), new Date()],
            Mtime: '',
            supply_id:0,
            t_supply_id:0,
            product_sku_id:0,
          },

          tableDatao:[],
        formo:[],
        /*列表数据*/
         tableDatao: [],
          /*一页多少条*/
          pageSizeo: 20,
          /*一共多少条数据*/
          totalDataNumbero: 0,
          /*当前是第几页*/
          curPageo: 1,
          selectData: '',

          supplyArr:[],
          productArr:[],

          loadingo:false,
          loadingw:false,

        pickerOptions: {
          disabledDate: (time) => {
            // 计算允许的最小日期（当前月前推6个月的第一天）
            const minDate = new Date()
            minDate.setMonth(minDate.getMonth() - 6)
            minDate.setDate(1)
            minDate.setHours(0, 0, 0, 0)

            // 计算允许的最大日期（当前月最后一天）
            const maxDate = new Date()
            maxDate.setMonth(maxDate.getMonth() + 1, 0)
            maxDate.setHours(23, 59, 59, 999)

            // 禁用不在时间范围内的日期
            return time < minDate || time > maxDate
          }
        },
      };
    },
    computed: {
      selectedWarehousesText() {
        return this.selectedWarehouses.length 
          ? this.selectedWarehouses.map(w => this.warehouses.find(item => item.value === w).label).join(', ')
          : '选择仓库';
      },
      selectedLocationsText() {
        return this.selectedLocations.length
          ? this.selectedLocations.map(l => this.locations.find(item => item.value === l).label).join(', ')
          : '选择库位';
      }
    },


  created() {
    /*获取数据*/
    var self =this;
    self.getSupplys();
    self.getSupply()
    self.getVisit();
    self.getData();
    self.getDataw();
    self.getDatao();
    setTimeout(() => {
      self.initCharts1();
      self.initCharts2();
    }, 500);
  },
    methods: {
      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supplyArr = data.data.supply
                self.productArr =  data.data.product
                self.form_w.supply_id = self.supplyArr[0].supply_id
                self.form_w.t_supply_id = self.supplyArr[0].supply_id
                self.form_w.product_sku_id = self.productArr[0].product_sku_id

                self.form_o.supply_id = self.supplyArr[0].supply_id
                self.form_o.t_supply_id = self.supplyArr[0].supply_id
                self.form_o.product_sku_id = self.productArr[0].product_sku_id
                })
                .catch(error => {
                });
        },
      getDatao(){
        this.getTableListo();
      },
        /*选择第几页*/
        handleCurrentChangeo(val) {
          this.curPageo = val;
          this.getTableListo();
        },
  
        /*每页多少条*/
        handleSizeChangeo(val) {
          this.curPageo = 1;
          this.pageSizeo = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableListo() {
          let self = this;
        //   let Params = this.formInline;
        //   Params.page = self.curPage;
        //   Params.list_rows = self.pageSize;
        let startTime = '';
          let endTime = '';
          if (this.form_o.time) {
            startTime = changeDate(this.form_o.time[0]);
            endTime = changeDate(this.form_o.time[1]);
          }


          let Params = {
            supply_id:self.form_o.supply_id,
            t_supply_id:self.form_o.t_supply_id,
            product_sku_id:self.form_o.product_sku_id,
            timeType:this.form_o.timeType,
            startTime,
            endTime,
          };
          self.loadingo = true;
          Out_managementApi.record(Params, true)
            .then(data => {
              self.loadingo = false;
              self.tableDatao = data.data.list.data;
              self.totalDataNumbero = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmito() {
          this.curPage = 1;
          this.getTableListo();
        },
  


      getDataw(){
        this.getTableListw();
      },
        /*选择第几页*/
        handleCurrentChangew(val) {
          this.curPagew = val;
          this.getTableListw();
        },
  
        /*每页多少条*/
        handleSizeChangew(val) {
          this.curPagew = 1;
          this.pageSizew = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableListw() {
          let self = this;
        let startTime = '';
          let endTime = '';
          if (this.form_w.time) {
            startTime = changeDate(this.form_w.time[0]);
            endTime = changeDate(this.form_w.time[1]);
          }


          let Params = {
            supply_id:self.form_w.supply_id,
            t_supply_id:self.form_w.t_supply_id,
            product_sku_id:self.form_w.product_sku_id,
            timeType:this.form_w.timeType,
            startTime,
            endTime,
          };
          self.loadingw = true;
          Warehouse_managementApi.record(Params, true)
            .then(data => {
              self.loadingw = false;
              self.tableDataw = data.data.list.data;
              self.totalDataNumberw = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmitw() {
          this.curPage = 1;
          this.getTableListw();
        },

        selectTypew(){

    
        this.getTableListw();
        },
        selectTypeo(){

    
        this.getTableListo();
        },
        changeStorew() {
    
    
            this.getTableListw();
      },
      changeStoreo() {
          

            this.getTableListo();
      },

      getSupply(){
        let self = this;
        Existing_inventoryApi.getSupply({})
          .then((data) => {
            self.loading = false;
            self.supply = data.data;
          })
          .catch((error) => {});

      },
          /*获取数据*/
    getData() {
      let self = this;
   
        Existing_inventoryApi.getCount({})
          .then((data) => {
            self.loading = false;
            self.obj = data.data;
          })
          .catch((error) => {});



    },
        
    /*获取数据*/
    getVisit() {
      let self = this;
      IndexApi.visit({})
        .then((data) => {
          self.activities = data.data.rvisit

        })
        .catch((error) => {});
    },
    jumpClick(item){
      if(item.jump_url){
        var query = {};
        if(item.tid){
          query['id'] =  item.tid;
        }
        if(item.tid){
          query['type'] =  item.ttype;
        }
        this.$router.push({
          path: item.jump_url,
          query: query
        });
      }
   
    },
    labelClick(id){
      let self = this;
      IndexApi.handleVisit({
        'id':id
      })
        .then((data) => {
          self.getVisit()

        })
        .catch((error) => {});
    },
      initCharts1() {
        var self = this;
       

        Existing_inventoryApi.getStatis(self.form)
          .then((data) => {
            data = data.data;
            const trendChart = echarts.init(self.$refs.trendChart);
            trendChart.setOption(data);
          })
          .catch((error) => {});


     
          
   
  
      },
      initCharts2(){
        var self = this;
        Existing_inventoryApi.getWarehouseStats(self.form)
          .then((data) => {
            data = data.data;
            self.loading = false;
            const pieChart = echarts.init(this.$refs.pieChart);
            pieChart.setOption(data)
           
          }).catch((error) => {})
      

  
      },
      toggleWarehouseDropdown() {
        this.showWarehouseDropdown = !this.showWarehouseDropdown;
        this.showLocationDropdown = false;
        this.showSupplierDropdown = false;
  
      },
      toggleLocationDropdown() {
        this.showLocationDropdown = !this.showLocationDropdown;
        this.showWarehouseDropdown = false;
        this.showSupplierDropdown = false;
   
      },
      toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
   
        this.showWarehouseDropdown = false;
        this.showLocationDropdown = false;
      },
      selectWarehouse(item) {
        const index = this.selectedWarehouses.indexOf(item.value);
        if (index === -1) {
          this.selectedWarehouses.push(item.value);
        } else {
          this.selectedWarehouses.splice(index, 1);
        }
      },
      selectLocation(item) {
        const index = this.selectedLocations.indexOf(item.value);
        if (index === -1) {
          this.selectedLocations.push(item.value);
        } else {
          this.selectedLocations.splice(index, 1);
        }
      },
      selectSupplier(item) {
        this.selectedSupplier = item;
        this.form.supply_id = item.supply_id
        this.showSupplierDropdown = false;

        this.initCharts1();
   
      },
 
      handleSearch() {
        // 实现查询逻辑
        this.initCharts1();
        this.initCharts2();
      },
      handleReset() {
        this.selectedWarehouses = [];
        this.selectedLocations = [];
        this.selectedSupplier = null;
        this.selectedSuppliers = null;
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.supply_id = ''
        this.form.warehouse_id = ''
        this.initCharts1();
        this.initCharts2();
      },
      handleExport() {
        // 实现导出逻辑
      },
      handlePrint() {
        // 实现打印逻辑
      },
      handleRefresh() {
        // 实现刷新逻辑
      },
      handleDetail(row) {
        // 实现查看详情逻辑
      }
    }
  };
  </script>
  
  <style scoped>
  .btn-primary {
    @apply bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  
  .btn-default {
    @apply bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  
  .max-h-40::-webkit-scrollbar {
    width: 6px;
  }
  
  .max-h-40::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/home/homeb.vue